export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
}

export const deleteCookie = (name: string, extraPart?: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${extraPart}`
}

export const setCookie = (name: string, value: string, extraPart?: string) => {
  document.cookie = `${name}=${value}; path=/; ${extraPart}`
}
